module.exports = __webpack_public_path__ + "img/vgx.a2be0cb4.svg";